class Question {
    questionId: number;
    fieldId: number;
    formId: number;
    dataKey: string;
    label: string;
    required: number;
    hidden: number;
    sensitive: boolean;
    minLength: number;
    selectedType: string;
    type: string;
    variant: string | null;
    options: any[];
    values: any[];
    listName: string;
    defaultValue: any;
    maxLength: number;
    sequence: number;
    markdown: string | null;
    shape: string | null;
    readonly: boolean;

    constructor() {
        this.questionId = 0;
        this.fieldId = 0;
        this.formId = 0;
        this.dataKey = "";
        this.label = "";
        this.required = 1;
        this.hidden = 0;
        this.sensitive = false;
        this.minLength = 0;
        this.selectedType = "string";
        this.type = "text";
        this.variant = null;
        this.options = [];
        this.values = [];
        this.listName = "";
        this.defaultValue = null;
        this.maxLength = 200;
        this.sequence = 0;
        this.markdown = null;
        this.shape = null;
        this.readonly = false;
    }
}

export default Question;